import { SrtFormValues } from '../types';

const EMPLOYER_TO_WORK_CENTER_FIELDS: Record<string, string> = {
    razonSocialEmpleador: 'razonSocialCentro',
    cuitDatosEmpleador: 'cuitCentro'
};

const isBlank = (value: any) =>
    value === null || value === undefined || String(value).trim() === '';

export const applyEmployerDefaultsToWorkCenter = (
    values: SrtFormValues
): SrtFormValues => ({
    ...values,
    razonSocialCentro: isBlank(values.razonSocialCentro)
        ? values.razonSocialEmpleador || ''
        : values.razonSocialCentro,
    cuitCentro: isBlank(values.cuitCentro)
        ? values.cuitDatosEmpleador || ''
        : values.cuitCentro
});

export const updateEmployerFieldWithWorkCenterDefault = (
    values: SrtFormValues,
    fieldName: string,
    value: any
): SrtFormValues => {
    const workCenterField = EMPLOYER_TO_WORK_CENTER_FIELDS[fieldName];
    if (!workCenterField) return { ...values, [fieldName]: value };

    const shouldUpdateWorkCenter =
        isBlank(values[workCenterField]) || values[workCenterField] === values[fieldName];

    return {
        ...values,
        [fieldName]: value,
        ...(shouldUpdateWorkCenter ? { [workCenterField]: value } : {})
    };
};